/** Permissions-related error messages. */
// A user made an API request for which they do not have the proper role.
export const API_FORBIDDEN_RESPONSE_MESSAGE = 'Unauthorized request.';
// A user tried to mount a component for which they do not have the proper role.
export const UNAUTHORIZED_MESSAGE = 'You are not authorized to view this page.';

/** Other error messages. */
export const CONTACT_INFORMATION_FOR_ERROR_MESSAGE = 'If this problem persists, please contact High Peaks Solutions at support@highpeakssolutions.com.';

// Something unexpected happened.
export const GENERIC_ERROR_MESSAGE = 'Something went wrong. If this problem persists, please contact High Peaks Solutions at support@highpeakssolutions.com.';
// The WAF blocked a request.
export const WAF_BLOCK_MESSAGE = 'Request blocked. For assistance, contact High Peaks Solutions at support@highpeakssolutions.com.';
